<template>
  <div>
    <div id="mySidebar" class="mySidebar">
      <tabs v-if="this.isCollapsed == false" value="Description" tab-content-classes="text-center">
        <tab-pane title="Grupos" key="home">
          <input
            @keyup="mantenerRes"
            type="search"
            class="form-control input-sm searchBox"
            placeholder="Buscar Patente"
            v-model="search"
            id="searchPat"
            style="border-radius:0px !important;"
            autocomplete="off"
          />
          <div v-if="this.search" class="searchWindow" id="searchWindow">
            <div v-for="grupo in grupos" :key="grupo.grupo_nombre">
              <div v-for="vehiculo in filterVehicles(grupo)" :key="vehiculo.veh_id">
                <p-button
                  @click="searchPatent(vehiculo.veh_id)"
                  type="default"
                  link
                  style="width: 100%; margin: 0px;    border-radius: 0px !important;"
                >{{ vehiculo.veh_id }}</p-button>
              </div>
            </div>
          </div>

          <collapse v-if="vehiculosDisponibles">
            <collapse-item
              v-for="grupo in grupos"
              :key="grupo.grupo_nombre"
              :title="grupo.grupo_nombre"
              :id="grupo.grupo_nombre"
              :propActive="false"
            >
              <table style="width:100%">
                <tr
                  v-for="gp in grupo.grupos_vehiculos"
                  :key="gp.veh_id"
                  :class="tableRowClassName(gp.veh_id)"
                >
                  <td class="patente_val"
                    @click="selectPatente(gp.veh_id)"
                    @dblclick="mapPanToPin(gp.veh_id)"
                    >{{ gp.veh_id}}
                  </td>
                </tr>
              </table>
            </collapse-item>
          </collapse>

          <!-- </tab-pane>
          <tab-pane title="Zonas" key="profile">-->
        </tab-pane>
        <!-- <tab-pane title="Detalle" key="messages"></tab-pane> -->
      </tabs>
    </div>
    <div @click="openNav()" class="buttonSidebar" id="buttonSidebar">
      <span class="sidebar-mini-icon arrow">
        <i v-if="this.isCollapsed" class="nc-icon nc-minimal-right"></i>
        <i v-else class="nc-icon nc-minimal-left"></i>
      </span>
    </div>
  </div>
</template>


<script>

import {
  Collapse,
  CollapseItem,
  Tabs,
  TabPane
} from "src/components/UIComponents";


import { mapState } from "vuex";
import vehiculoService from "../../../services/vehiculo";
import {EventBus} from '../../../../src/eventBus'
import Vue from 'vue'
import Vue2TouchEvents from 'vue2-touch-events'


Vue.use(Vue2TouchEvents)

export default {

  components: {
    Tabs,
    TabPane,
    Collapse,
    CollapseItem
  },

  inject: {
    activate: {
      default: () => {}
    }
  },

  data() {
    return {
      vehiculosDisponibles: false,
      search: "",
      route: [],
      isCollapsed: false,
      grupoActivo: ''
    };
  },

  computed: {
    ...mapState(["patenteSelected", "positionQuery","grupos","hola"])
  },

  created() {
    this.getVehiculos();
  },

  watch: {
      patenteSelected() {
        this.uncollapseParentGroup(this.patenteSelected)
      }
  },

  methods: {

   mapPanToPin(vehId) {
    EventBus.$emit('mapPanToPin', {'vehId': vehId})
   },

    mantenerRes() {
      var input = document.getElementById("searchPat");
      if (!input.value) return false;
      if (input.value.length.trim == 0) {
        //Esta funcion evita errores inecesarios generados al apretar enter o retroceso cuando el input de busqueda esta vacio.
        //En caso de que se genere el mismo error al apretar otra tecla, agregarlo en el condicional del if de arriba, con su codigo ascii correspondiente
        return false;
      }
      document.getElementById("searchWindow").style.display = "block";
    },

    searchPatent(pat) {
      document.getElementById("searchPat").value = pat;
      document.getElementById("searchWindow").style.display = "none";
      // document.getElementById("searchWindow").selectionStart = 0
      let children = document
        .getElementById("accordion")
        .getElementsByClassName("card-plain");
      for (var i = 0; i < children.length; i++) {
        var patentes = children[i].querySelectorAll(".card-body>table>tr");
        for (var j = 0; j < patentes.length; j++) {
          patentes[j].classList.remove("elegida");
          var val = patentes[j].querySelector(".patente_val").innerHTML;
          if (pat.trim() == val.trim()) {
            patentes[j].className = "elegida";
            // children[i].propActive = true;
          }
        }
      }
      this.selectPatente(pat)
    },

    uncollapseParentGroup(pat) {
      var gr;
      var ve;
      for (gr = 0; gr < this.grupos.length; gr++) {

        for (ve = 0; ve < this.grupos[gr].grupos_vehiculos.length; ve++) {

            if (pat == this.grupos[gr].grupos_vehiculos[ve].veh_id) {
                this.grupoActivo = this.grupos[gr].grupo_nombre
                EventBus.$emit('uncollapseItem', {'id': this.grupoActivo})
                break
            }
            else{
                EventBus.$emit('collapseItem', {'id': this.grupos[gr].grupo_nombre})
            }
        }
      }
    },

    selectPatente(pat) {
      var self = this
      var width = window.innerWidth
      if (width > 768) {
        self.$store.commit("selectPatente", {
          patenteVehiculo: pat
        });
      } else {
        self.$store.dispatch("selectPatente", pat).then(
          self.mapPanToPin(pat),
          this.openNav()  
        )
      }
    },

    getVehiculos() {
      
      vehiculoService.index().then(res => {
        this.$store.commit("setGrupos", { gruposVehiculos: res.data });
      });
      this.vehiculosDisponibles = true;
    },

    filterVehicles(item) {
      return item.grupos_vehiculos.filter(vehiculo => {
        return vehiculo.veh_id.match(this.search.toUpperCase());
      });
    },


    // Método que resalta el vehículo elegido dentro de la lista.
    tableRowClassName(veh) {
      if (veh == this.patenteSelected) {
        return "elegida";
      } else {
        return "";
      }
    },

    openNav() {
      if (this.isCollapsed == true) {
        var self = this;
        setTimeout(function() {
          self.isCollapsed = false;
        }, 400);
        document.getElementById("mySidebar").classList.remove("expandSidebar");
        document
          .getElementById("buttonSidebar")
          .classList.remove("expandButtonSidebar");
      } else {
        document.getElementById("mySidebar").classList.add("expandSidebar");
        document
          .getElementById("buttonSidebar")
          .classList.add("expandButtonSidebar");
        this.isCollapsed = true;
      }
    }
  }
};

</script>

<style>

.patente_val {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently */
}

table > tr > td {
  cursor: pointer;
  padding: 5% 0%;
}

table > tr > td:hover {
  background-color: #f56c6c;
}

.elegida {
  background-color: #f56c6c;
  font-weight: bold;
}

.searchBox {
  width: 100%;
  height: 40px;
  margin-left: 0%;
  background-color: #dadada !important;
}

.searchWindow {
  position: absolute;
  z-index: 2;
  background-color: #a1a1a1;
  width: 90%;
  left: 5%;
  border: 2px solid black;
  border-top: none;
}

.arrow {
  font-size: 20px;
  font-weight: bolder;
  color: #bebebe;
}

.expandSidebar {
  width: 0px !important;
  min-width: 0px !important;
  border-right: 0 solid !important;
}

.buttonSidebar {
  position: absolute;
  height: 85px;
  background-color: #212120;
  width: 40px;
  left: 15%;
  z-index: 1;
  transition: all 0.5s ease;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 2px solid;
  border-left: 2px solid;
  /* border-color: #868483; */
  border-color: #bebebe;
  border-top-right-radius: 0.7rem !important;
  border-bottom-right-radius: 0.7rem !important;
}
@media all and (max-width: 1650px) {
  .buttonSidebar {
    left: 250px;
  }
  .mySidebar {
    width: 250px !important;
  }
  .expandSidebar {
    width: 0px !important;
    min-width: 0px !important;
    border-right: 0 solid !important;
  }
}

.buttonSidebar:hover {
  background-color: #868483;
}

.buttonSidebar:hover .arrow {
  color: #272727;
}

.expandButtonSidebar {
  left: 0%;
  border-left: none;
  transition: all 0.5s ease;
}

.mySidebar {
  overflow: overlay;
  height: 100%;
  width: 15%;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: #212120;
  transition: 0.5s;
  padding-top: 10px;
  border-color: #000000;
}

.mySidebar a {
  padding: 8px 8px 8px 8px;
  text-decoration: none;
  font-size: 18px;
  color: #818181;
  font-weight: bolder;
  display: block;
  transition: 0.3s;
}

.mySidebar::-webkit-scrollbar {
  display: none;
}

.mySidebar:hover::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    display: block;
}


.mySidebar::-webkit-scrollbar-thumb {
    background: #ccc;
}

.mySidebar::-webkit-scrollbar-thumb:hover {

    background: #b3b3b3;
    box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
}

.mySidebar::-webkit-scrollbar-thumb:active {
    border-radius: 10px;
}

</style>
